"use client";

import { Button } from "@/components/ui/button";
import { ChatBubbleIcon } from "@radix-ui/react-icons";
import { RefreshCw } from "lucide-react";

// Comment Header Component
export interface CommentHeaderProps {
  loading: boolean;
  visibleCommentsCount: number;
  onRefresh: () => void;
  sortBy: "newest" | "oldest";
  toggleSort: () => void;
}

export function CommentHeader({
  loading,
  visibleCommentsCount,
  onRefresh,
  sortBy,
  toggleSort,
}: CommentHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6 border-b-3 border-black">
      <div className="flex items-center gap-2 bg-black text-white p-1.5 px-4 -mb-1 rounded">
        <ChatBubbleIcon className="w-5 h-5" />
        <h3 className="text-sm font-medium">
          <span className="hidden md:inline-block">Comments</span>{" "}
          {!loading && `(${visibleCommentsCount})`}
        </h3>
      </div>
      <div className="flex items-center gap-2 -mb-0.5">
        <Button
          variant="default"
          className="bg-black text-white p-1 px-4 text-sm font-medium rounded border-none hover:bg-gray-800"
          size="sm"
          onClick={onRefresh}
          disabled={loading}
        >
          <RefreshCw className="h-5 w-5 mr-2" />
          Refresh
        </Button>
        <Button
          variant="default"
          className="bg-black text-white p-1 px-4 text-sm font-medium rounded border-none hover:bg-gray-800"
          size="sm"
          onClick={toggleSort}
        >
          Sort: {sortBy === "newest" ? "Newest" : "Oldest"}
        </Button>
      </div>
    </div>
  );
}
